module.exports = __webpack_public_path__ + "img/b94acbdb5e83e0c976738edea2655b03.69c7c85d.png";